// Input validation and sanitization utilities

export const sanitizeInput = (input: string): string => {
  if (!input) return '';
  
  // Remove HTML tags and script content
  return input
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<[^>]*>/g, '')
    .trim()
    .slice(0, 1000); // Limit length
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) && email.length <= 254;
};

export const validatePassword = (password: string): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  
  if (!/(?=.*[a-z])/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (!/(?=.*[A-Z])/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (!/(?=.*\d)/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  if (!/(?=.*[!@#$%^&*])/.test(password)) {
    errors.push('Password must contain at least one special character (!@#$%^&*)');
  }
  
  return { valid: errors.length === 0, errors };
};

export const validateCompanyName = (name: string): boolean => {
  if (!name) return true; // Optional field
  return name.length >= 2 && name.length <= 100 && /^[a-zA-Z0-9\s\-&.,()]+$/.test(name);
};

export const validateContactNumber = (number: string): boolean => {
  if (!number) return true; // Optional field
  return /^[+]?[\d\s\-()]{7,15}$/.test(number);
};

export const validateFeedbackSubject = (subject: string): boolean => {
  return subject.length >= 5 && subject.length <= 200;
};

export const validateFeedbackMessage = (message: string): boolean => {
  return message.length >= 10 && message.length <= 2000;
};

export const sanitizeAndValidate = (
  input: string,
  validator: (input: string) => boolean
): { sanitized: string; valid: boolean } => {
  const sanitized = sanitizeInput(input);
  const valid = validator(sanitized);
  return { sanitized, valid };
};